import { EdgenDrawerCallableProps } from "../../EdgenDrawerCallable";
import { Opportunity, OpportunityTypeEnum } from "@features/api/memberApi";

export interface AlphaPickPricingModalCallableParams extends EdgenDrawerCallableProps {
  onClose?: () => void;
  needCreditAmount?: number;
  isPC?: boolean;
  routerType?: string;
  opportunity?: Opportunity;
  credits?: number;
  trackingModuleName?: string;
  trackingSymbol?: string;
  paywallCopyOverrides?: {
    title?: string;
    subtitle?: string;
    features?: string[];
    hideSocialProof?: boolean;
    /** V3 onboarding paywall (Figma 96138:32738)：隐藏 Offer 倒计时 */
    hideOfferCountdown?: boolean;
  };
  /** 为 true 时不渲染内容区 close Icon（PC / H5 通用） */
  hideCloseButton?: boolean;
  /** 为 true 时在主 CTA 下展示「Just Look around」 */
  showJustLookAroundButton?: boolean;
  /** 次要按钮点击；未传时等同 onClose */
  onJustLookAroundClick?: () => void;
  /**
   * 弹窗内**导航类**动作（如「View all plans」→ `/member`）触发的关闭动作。
   * 只关弹窗，**不**执行 `onClose` 的 dismiss 副作用（如调用方 `router.push` 回列表页），
   * 否则同 tick 两次导航：浏览器落点不确定，App 内 Detail WebView 会被 bridge 收走的同时
   * 又 SPA 跳到 `/member`（保活复用后串页）。未传时由 Callable 兜底为「仅关弹窗」。
   */
  onNavigateAway?: () => void;
  /**
   * 调用方取消（如页面卸载）。Callable 会等到当前 WebView 可见才弹窗，
   * 等待期间收到 abort 则放弃本次弹窗（避免弹在已离开的页面上）。
   */
  signal?: AbortSignal;
  /** Hero 背景图；onboarding 传 V3 `paywall-free-trial.webp` */
  heroBackgroundSrc?: string;
}

export const IpoEnum = {
  [OpportunityTypeEnum.IPO]: "ipo",
  [OpportunityTypeEnum.AI_PICK]: "ai_pick",
  [OpportunityTypeEnum.EARNINGS]: "earnings",
};
